import { EMPTY_BANK_INTERFACE_MONITORINGANY_MODEL } from "presentation/model/BankInterfaceMonitoring/BankInterfaceMonitoringMaintenanceModel";
import { useState } from "react";
import { createContainer } from "react-tracked";

const {
    Provider: BankInterfaceMonitoringMaintenanceProvider,
    useTracked: useBankInterfaceMonitoringMaintenanceTracked
} = createContainer(() => useState(EMPTY_BANK_INTERFACE_MONITORINGANY_MODEL), {concurrentMode: true});
export { BankInterfaceMonitoringMaintenanceProvider, useBankInterfaceMonitoringMaintenanceTracked };

